export default "__VITE_ASSET__BqWB7vEi__"